<script setup>
import {defineProps} from 'vue'
import slugify from 'slugify'

const props = defineProps({
  title: String,
  anchor: String,
});

</script>


<template>
<section :id="props.anchor || slugify(props.title)" class="doc-jumbo">
  <h2 class="section-heading">{{ props.title }}</h2>
  <div class="jumbo-body">
    <slot></slot>
  </div>
</section>
</template>

<style scoped>
.doc-jumbo {
  scroll-margin-top: 1.5rem;
  background: var(--surface-card);
  border-radius: var(--radius-xl);
  padding: 2rem;
}

.section-heading {
  font-family: var(--font-heading);
  color: var(--text-heading);
  font-size: 1.375rem;
  font-weight: 600;
  line-height: var(--lh-tight);
  margin: 0 0 1.5rem;
}

.jumbo-body {
  color: var(--text-secondary);
  line-height: var(--lh-relaxed);
  max-width: 780px;
}

.jumbo-body :deep(p) {
  margin-bottom: 1rem;
}

.jumbo-body :deep(code),
.jumbo-body :deep(strong) {
  font-family: var(--font-heading);
  font-size: 0.85em;
  font-weight: 600;
  color: var(--text-heading);
  background: var(--surface-sunken);
  padding: 0.1rem 0.4rem;
  border-radius: var(--radius-xs);
}

.jumbo-body :deep(ul) {
  padding-left: 1.25rem;
}

.jumbo-body :deep(li) {
  margin-bottom: 0.5rem;
}
</style>
